import React, { useMemo, useRef, useState } from 'react';

import { htmlEditButton } from 'quill-html-edit-button';
import ReactQuill, { Quill } from 'react-quill';
import sanitizeHtml from 'sanitize-html';

import Alert from 'CommonComponents/Alert';
import Button from 'CommonComponents/Button';

import MinusCircleIcon from 'Assets/icons/minus.svg';
import PlusCircleIcon from 'Assets/icons/plus.svg';

import 'react-quill/dist/quill.snow.css';

Quill.register('modules/htmlEditButton', htmlEditButton);

export default function SupplierPortalSettingsUpdate(props) {
    const quillRef = useRef();

    const [message, setMessage] = useState(props.settings.message || '');
    const [show, setShow] = useState(false);

    const modules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: [] }],
                ['link'],
                ['clean'],
                [{ color: [] }],
            ],
            htmlEditButton: {
                buttonHTML: 'HTML',
            },
        }),
        [],
    );

    const formats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'video'];

    const options = {
        allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'p', 'span', 'b', 'i', 'em', 'strong', 'u', 'a', 'ol', 'ul', 'li'],
        allowedAttributes: {
            a: ['href'],
            '*': ['class', 'target', 'style'],
        },
        allowedStyles: {
            '*': {
                color: [/^.*$/],
            },
        },
    };

    const update = () => {
        const clean = sanitizeHtml(message, options);

        props.updateMessage(clean);
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-flex-row tw-justify-between tw-pb-3">
                <div>
                    <h3 className="tw-text-blue tw-text-2xl tw-font-semibold">{$t('Preamble')}</h3>
                </div>
                <div className="tw-flex tw-flex-row tw-gap-x-1">
                    {!show && (
                        <div className="tw-cursor-pointer" onClick={() => setShow(true)}>
                            <div className="tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full">
                                <PlusCircleIcon className="tw-h-3.5 tw-w-3.5 tw-text-white" />
                            </div>
                        </div>
                    )}
                    {!!show && (
                        <div className="tw-cursor-pointer" onClick={() => setShow(false)}>
                            <div className="tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full">
                                <MinusCircleIcon className="tw-h-3.5 tw-w-3.5 tw-text-white" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {show && (
                <div className="tw-space-y-4">
                    <div className="tw-mb-3">
                        <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            value={message}
                            onChange={setMessage}
                            className="tw-text-xs"
                        />
                    </div>

                    {message.length > 4000 && (
                        <div className="d-flex justify-content-end">
                            <Alert className="tw-my-2" type="error">
                                {$t('The length of the preamble should not exceed 4000 characters.')}
                            </Alert>
                        </div>
                    )}

                    <div>
                        <Button variant="primary" disabled={message.length > 4000 || props.request} onClick={update}>
                            {$t('Save')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}
